import { render, staticRenderFns } from "./AccountLoginRegister.vue?vue&type=template&id=81ac7466&scoped=true&"
import script from "./AccountLoginRegister.vue?vue&type=script&lang=js&"
export * from "./AccountLoginRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ac7466",
  null
  
)

export default component.exports